/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { VERSION, RESOURCE_CACHE_PROVIDER, platformBrowserDynamic, ɵCompilerImpl, ɵplatformCoreDynamic, ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS, ɵResourceLoaderImpl } from "./public_api";
export { JitCompilerFactory as ɵa } from "./src/compiler_factory";
export { CachedResourceLoader as ɵb } from "./src/resource_loader/resource_loader_cache";
//# sourceMappingURL=platform-browser-dynamic.js.map


// WEBPACK FOOTER //
// ../../../packages/platform-browser-dynamic/esm5/platform-browser-dynamic.js